const actions = {
    resize: (context) => {
        context.commit('SET_WIDTH', window.innerWidth);
        context.commit('SET_HEIGHT', window.innerHeight);
        context.commit('SET_ISTOUCH', 'ontouchstart' in document.documentElement);
    },
};

export default actions;
